<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'modal_qr_header_2fa_qr_code' | translate"></bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section mod-wide pb-25 pt-25">
			<div class="center-block flex-center-horizontal">
				<qrcode class="qrcode-container" [qrdata]="qr" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
			</div>
			<div class="mt-20">
				<button type="button" class="btn btn-default" data-dismiss="modal" (click)="close()" tabindex="30004">
					{{ "close" | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
